@if (!items) {
  <mat-spinner></mat-spinner>
}

@if (!!items && items.length === 0) {
  <span>
    No assignments
  </span>
}

@if (!!items) {
  <div
    cdkDropList
    [cdkDropListData]="items"
    (cdkDropListDropped)="drop($event)"
  >
    @for (item of items; track $index) {
      <app-queue-menu-item [input]="item"
                            cdkDrag
                            [cdkDragData]="item"
                            [cdkDragDisabled]="!vehicle"
      >
      </app-queue-menu-item>
    }
  </div>
}
